<template>
  <v-container class="wrapper">
    <v-row no-gutters>
      <v-col lg="12">
      <p class="estimated-costs">Estimated cost</p>
      <span class="costs"><strong>$ {{amount > 0 ? amount : '-'}}&nbsp; </strong></span>/ 
       <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              v-on="on"
              class="menu text-none"
              :ripple="false"
            >
            {{selectedPeriod}}
              <v-icon right>fas fa-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in period"
              :key="index"
              @click="selectedPeriod = item"
            >
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      period: ["hour", "day", "month"],
      selectedPeriod: "day"
    };
  },
  props: ["details"],
  computed: mapGetters(["amount"]),
  methods: mapActions(["setPeriod", "calculateAmount"]),
  watch: {
    selectedPeriod() {
      this.setPeriod(this.selectedPeriod);
      this.calculateAmount();
    }
  },
  created() {
    this.setPeriod(this.selectedPeriod);
    // this.calculateAmount();
  }
};
</script>

<style scoped>
.estimated-costs {
  text-align: center;
  font: 1.3em "Montserrat" !important;
}

.costs {
  text-align: center;
  font: 1.5em "Montserrat" !important;
}

.menu {
  font: 0.9em "Montserrat" !important;
  color: white !important;
}

.wrapper {
  color: white;
}
</style>
